module.exports = __webpack_public_path__ + "media/img/home/directions/list-4-2fa17ff85d93f4de8b89626bb9a67d85.svg";